import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import Constants from '@usas/ui-web/utils/Constants';

const GetOfficialPositionTypeData = (orgLevelId, hasEvaluationForm, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...',
      orgLevelId: orgLevelId,
      hasEvaluationForm: hasEvaluationForm
    };
    setState(newState);

    const orgLevelIdForUrl = orgLevelId ? encodeURIComponent(orgLevelId) : '';
    const hasEvaluationFormForUrl = hasEvaluationForm === true  || hasEvaluationForm === false ? encodeURIComponent(hasEvaluationForm) : '';
    const url = orgLevelIdForUrl ? `/OfficialPositionType?orgLevelId=${orgLevelIdForUrl}&hasEvaluationForm=${hasEvaluationFormForUrl}` : `/OfficialPositionType?hasEvaluationForm=${hasEvaluationFormForUrl}`;
    PersonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const data = JSON.parse(JSON.stringify(arrayData));
          const blankPosition = { officialPositionTypeId: Constants.DEFAULT_ID };
          data.unshift(blankPosition);
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            options: data.map((position) => { return { id: position.officialPositionTypeId, name: position.officialPositionTypeId !== Constants.DEFAULT_ID ? `${position.positionTypeName || ''} (${position.positionAbbreviation || ''})` : '--' } }),
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetOfficialPositionTypeData;